import React from "react";
import api from "../common/apiClient";
import SummaryAPI from "../common/SummaryApi";

const BannerTable = ({ banners, onRefresh }) => {
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this banner?")) return;

    await api({
      method: SummaryAPI.deleteBanner.method,
      url: SummaryAPI.deleteBanner.url(id)
    });

    onRefresh();
  };

  if (!banners.length) {
    return <p className="text-gray-500">No banners found</p>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {banners.map((banner) => (
        <div
          key={banner._id}
          className="border rounded overflow-hidden shadow-sm"
        >
          <img
            src={banner.image}
            alt="Banner"
            className="w-full h-40 object-cover"
          />

          <div className="p-2 flex justify-between items-center">
            <span className="text-sm text-gray-600">
              {banner.topCategory?.name}
            </span>

            <button
              onClick={() => handleDelete(banner._id)}
              className="text-red-600 text-sm"
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BannerTable;
